var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "cash_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#cash_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M22.778 22.222c-1.389 0-2.57-.486-3.542-1.458-.972-.973-1.458-2.153-1.458-3.542 0-1.389.486-2.57 1.458-3.542.973-.972 2.153-1.458 3.542-1.458 1.389 0 2.57.486 3.542 1.458.972.973 1.458 2.153 1.458 3.542 0 1.389-.486 2.57-1.458 3.542-.973.972-2.153 1.458-3.542 1.458ZM7.222 27.778V6.667h31.111v21.11H7.223ZM13.89 25h17.778c0-1.083.377-2.002 1.132-2.757.754-.755 1.673-1.132 2.756-1.132v-7.778c-1.083 0-2.002-.377-2.756-1.132-.755-.754-1.132-1.673-1.132-2.756H13.889c0 1.083-.377 2.002-1.132 2.756-.755.755-1.674 1.132-2.757 1.132v7.778c1.083 0 2.002.377 2.757 1.132.755.755 1.132 1.674 1.132 2.757ZM1.667 33.333V11.667h2.778v18.888h28.888v2.778H1.667Z"
}))));
export default SvgCash;